// extracted by mini-css-extract-plugin
module.exports = {"modal":"policy_info_modal_modal__3Oh0l","modalheader":"policy_info_modal_modalheader__HVyba","header":"policy_info_modal_header__2Z-c7"};